<template>
    <BreadCrumb PageTitle="Détail de la Demande" />
    <DetailDemande />
</template>
  
<script lang="ts">
  import { defineComponent } from "vue";
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import DetailDemande from "../../components/Demande/DetailDemande.vue";
  
  export default defineComponent({
    name: "DetailDemandePage",
    components: {
      BreadCrumb,
      DetailDemande,
    },
  });
</script>